import { Box, HStack, Spacer, VStack } from "@chakra-ui/react";
import { NavBar } from "../components/NavBar";
import { CkbIcon, JoyIDIcon, MetaMaskIcon } from "../icons/Icons";
import { Footer } from "../components/Footer";
import { ChainsNavigator } from "../components/ChainsNavigator";
import React from "react";
import { useNavigate } from "react-router-dom";
import { RoutesData } from '../data/RoutesData';
import { ViewData } from "../data/ViewData";

export const StartPage = () => {
    const nav = useNavigate();
    
    if(!ViewData.wallet){
        nav(RoutesData.Home);
    }
    return (
        <VStack spacing={4} maxW="960px" mx="auto">
            <NavBar />
            <ChainsNavigator></ChainsNavigator>
            <Footer />
        </VStack>
    );
}